import styled, { css } from "styled-components";
import { Handle } from "@xyflow/react";
import { rawColors } from "../../../design-system/tokens/colors";

/**
 * Connection ports — invisible on KG canvas; visible when `$visible` (data model builder).
 */
export const StyledHandle = styled(Handle)<{ $visible?: boolean }>`
  width: 10px;
  height: 10px;
  min-width: 10px;
  min-height: 10px;
  box-sizing: border-box;

  ${({ $visible }) =>
    $visible
      ? css`
          opacity: 1;
          background: ${rawColors.structural.white};
          border: 1.5px solid ${rawColors.accent.tableBlue};
          box-shadow: 0 0 0 2px ${rawColors.structural.white};

          &.react-flow__handle-connecting,
          &.react-flow__handle-valid {
            background: ${rawColors.accent.tableBlueBg};
            border-color: ${rawColors.accent.tableBlue};
            opacity: 1;
          }
        `
      : css`
          background: transparent;
          border: none;
          opacity: 0;

          &.react-flow__handle-connecting,
          &.react-flow__handle-valid {
            background: transparent;
            opacity: 0;
          }
        `}
`;
